"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DataTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _search = require("../../../helpers/search");

var _sorting = require("../../../helpers/sorting");

var _dates = require("../../../helpers/dates");

var _translations = require("../../../helpers/translations");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _SearchIcon = _interopRequireDefault(require("../../SearchIcon"));

var _Filter = _interopRequireDefault(require("../../Filter"));

var _LoadingOverlay = _interopRequireDefault(require("../../LoadingOverlay"));

require("./DataTable.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    stripeRow: {
      backgroundColor: theme.palette.primary.light
    }
  };
};

var DataTable = /*#__PURE__*/function (_React$Component) {
  _inherits(DataTable, _React$Component);

  var _super = _createSuper(DataTable);

  function DataTable() {
    var _this;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      filterTerm: '',
      data: [],
      filteredData: [],
      sortedHeader: '',
      sortDirection: null,
      filterColumns: [],
      selectedFilters: {}
    });

    _defineProperty(_assertThisInitialized(_this), "dataFilter", function (term) {
      var selectedFilters = _this.state.selectedFilters;
      var filteredData = (0, _search.filterBy)(term, _this.state.data, _this.props.tableDataMapping.headers); // filters rows based on selected filters now

      filteredData = filteredData.filter(function (row) {
        return !Object.entries(selectedFilters).some(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              filters = _ref2[1];

          return !filters.includes(row[key]) && filters.length > 0;
        });
      });

      _this.setState({
        filterTerm: term,
        filteredData: filteredData,
        sortedHeader: '',
        sortDirection: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatFilterColumns", function () {
      var columns = _this.props.tableDataMapping.headers;
      var columnsForFiltering = _this.props.columnsForFiltering;
      var filterColumns = Object.keys(columns).map(function (column) {
        var canFilter = columnsForFiltering.includes(column) || columnsForFiltering.length === 0;
        return {
          key: column,
          title: column,
          canFilter: canFilter
        };
      });

      _this.setState({
        filterColumns: filterColumns
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelection", function (selectedFilters) {
      _this.setState({
        selectedFilters: selectedFilters
      }, function () {
        return _this.dataFilter(_this.state.filterTerm);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFilter", function (filterKey, filterLabel) {
      var selectedFilters = (0, _lodash.cloneDeep)(_this.state.selectedFilters); // remove filter from selectedFilters

      selectedFilters[filterKey] = selectedFilters[filterKey].filter(function (selectedFilter) {
        return selectedFilter !== filterLabel;
      });

      _this.setState({
        selectedFilters: selectedFilters
      }, function () {
        return _this.dataFilter(_this.state.filterTerm);
      });
    });

    return _this;
  }

  _createClass(DataTable, [{
    key: "customColumnStylesGet",
    value: function customColumnStylesGet(name) {
      var styles = {};

      if (this.props.customColumnStyles) {
        this.props.customColumnStyles.forEach(function (row) {
          if (row.columnName === name) {
            Object.assign(styles, row.styles);
          }
        });
      }

      return styles;
    }
  }, {
    key: "dataSort",
    value: function dataSort(column) {
      var sortedData;
      var sortDirection = (0, _lodash.cloneDeep)(this.state.sortDirection);
      var clonedFilteredData = (0, _lodash.cloneDeep)(this.state.filteredData);

      if (this.state.sortedHeader !== column) {
        sortDirection = null;
      }

      switch (sortDirection) {
        case 'asc':
          sortDirection = 'desc';
          sortedData = (0, _sorting.sortDescending)(clonedFilteredData, column);
          break;

        case 'desc':
          sortDirection = null;
          sortedData = this.state.filterTerm ? (0, _search.filterBy)(this.state.filterTerm, (0, _lodash.cloneDeep)(this.state.data), this.props.tableDataMapping.headers) : (0, _lodash.cloneDeep)(this.state.data);
          break;

        default:
          sortDirection = 'asc';
          sortedData = (0, _sorting.sortAscending)(clonedFilteredData, column);
          break;
      }

      this.setState({
        sortedHeader: column,
        sortDirection: sortDirection,
        filteredData: sortedData
      });
    }
  }, {
    key: "headerCompose",
    value: function headerCompose() {
      var _this2 = this;

      var columns = this.props.tableDataMapping.headers;
      var headers = Object.keys(columns).map(function (key) {
        var sortIndicator = null;

        if (_this2.state.sortedHeader === columns[key] && _this2.state.sortDirection) {
          var arrow = _this2.state.sortDirection === 'asc' ? 'arrow_drop_down' : 'arrow_drop_up';
          sortIndicator = /*#__PURE__*/_react["default"].createElement(_material.Icon, {
            style: {
              fontSize: '18px'
            }
          }, arrow);
        }

        var rightAlignHeader = {};

        if (_this2.props.tableData.length > 0) {
          for (var i = 0; i < 2; i++) {
            var headerValue = _this2.props.tableData[0][columns[key]];

            if (headerValue[i] === '$') {
              rightAlignHeader = {
                justifyContent: 'flex-end'
              };
              break;
            }
          }
        }

        return /*#__PURE__*/_react["default"].createElement("th", {
          key: columns[key],
          className: "DataTable_columnHeader",
          onClick: function onClick() {
            return _this2.dataSort(columns[key]);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "DataTable_columnHeaderContents",
          style: rightAlignHeader
        }, /*#__PURE__*/_react["default"].createElement("span", null, key), sortIndicator));
      });
      return /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, headers));
    }
  }, {
    key: "rowCompose",
    value: function rowCompose(rowData, isEvenRow) {
      var _this3 = this;

      var _this$props = this.props,
          tableDataMapping = _this$props.tableDataMapping,
          tableData = _this$props.tableData,
          classes = _this$props.classes;
      var columns = tableDataMapping.headers;
      var row = Object.keys(columns).map(function (column) {
        var rowColumnValue = rowData[(0, _lodash.get)(columns, column)];

        var customColumnStyles = _this3.customColumnStylesGet(column);

        if (rowColumnValue instanceof Date) {
          rowColumnValue = (0, _dates.dateTimeStringFormat)(rowColumnValue);
        }

        var rightAlignCell = {};

        if (tableData.length > 0) {
          for (var i = 0; i < 2; i++) {
            var cellValue = tableData[0][columns[column]];

            if (cellValue[i] === '$') {
              rightAlignCell = {
                textAlign: 'right'
              };
              break;
            }
          }
        }

        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "".concat(column, "_").concat(rowData[tableDataMapping.id]),
          className: "DataTable_rowCell",
          style: Object.assign({}, rightAlignCell, customColumnStyles)
        }, rowColumnValue);
      });
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: rowData[tableDataMapping.id],
        className: isEvenRow ? '' : classes.stripeRow
      }, row);
    }
  }, {
    key: "rowsCompose",
    value: function rowsCompose() {
      var _this4 = this;

      var rows = this.state.filteredData.map(function (rowData, index) {
        var isEven = index % 2 === 1;
        return _this4.rowCompose(rowData, isEven);
      });
      return /*#__PURE__*/_react["default"].createElement("tbody", null, rows);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.tableData.length > 0) {
        this.formatFilterColumns();
        this.setState({
          data: this.props.tableData,
          filteredData: this.props.tableData
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(this.props.tableData, prevProps.tableData)) {
        this.setState({
          data: this.props.tableData,
          filteredData: this.props.tableData
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var debouncedDataFilter = (0, _lodash.debounce)(function (term) {
        return _this5.dataFilter(term);
      }, 200);
      var _this$props2 = this.props,
          downloadLoading = _this$props2.downloadLoading,
          showDownload = _this$props2.showDownload,
          showFilter = _this$props2.showFilter,
          tableData = _this$props2.tableData;
      var _this$state = this.state,
          filterColumns = _this$state.filterColumns,
          data = _this$state.data,
          selectedFilters = _this$state.selectedFilters;
      return /*#__PURE__*/_react["default"].createElement(_material.Paper, {
        elevation: 1
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_toolbar"
      }, showDownload && /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
        show: downloadLoading,
        width: "50px",
        height: "100%",
        indicatorHeight: "10px"
      }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: (0, _translations.getTranslations)('datatable_download'),
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        onClick: this.props.onDownloadClick,
        disabled: downloadLoading
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: downloadLoading ? '' : 'DataTable_downloadIcon'
      }, "file_download"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_searchAndFilterIcons"
      }, /*#__PURE__*/_react["default"].createElement(_SearchIcon["default"], {
        onSearchSubmit: debouncedDataFilter
      }), showFilter && /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
        columns: filterColumns,
        data: data,
        disabled: tableData.length === 0,
        onFilterChange: this.onFilterSelection,
        onFilterReset: this.onFilterSelection,
        selectedFilters: selectedFilters
      }))), showFilter && /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_filterChips"
      }, Object.entries(selectedFilters).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            filterList = _ref4[1];

        return filterList.map(function (filterLabel) {
          return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
            color: "secondary",
            key: filterLabel,
            label: filterLabel,
            onDelete: function onDelete() {
              return _this5.onRemoveFilter(key, filterLabel);
            },
            style: {
              margin: '0 5px 5px 0'
            }
          });
        });
      })), /*#__PURE__*/_react["default"].createElement("hr", {
        className: "DataTable_separator"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_centeringContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "DataTable_scrollContainer"
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: "DataTable_table"
      }, this.headerCompose(), this.rowsCompose())))));
    }
  }]);

  return DataTable;
}(_react["default"].Component);

exports.DataTable = DataTable;

_defineProperty(DataTable, "propTypes", {
  customColumnStyles: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    columnName: _propTypes["default"].string.isRequired,
    styles: _propTypes["default"].object.isRequired
  })),
  onDownloadClick: _propTypes["default"].func,
  showDownload: _propTypes["default"].bool,
  showFilter: _propTypes["default"].bool,
  tableData: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  tableDataMapping: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    headers: _propTypes["default"].object.isRequired
  }).isRequired,
  classes: _propTypes["default"].object.isRequired,
  downloadLoading: _propTypes["default"].bool,
  columnsForFiltering: _propTypes["default"].arrayOf(_propTypes["default"].string)
});

_defineProperty(DataTable, "defaultProps", {
  columnsForFiltering: []
});

var _default = (0, _styles.withStyles)(styles)(DataTable);

exports["default"] = _default;